/** Only an unhashed literal legacy path is normalized; explicit hashes always win. */
export const normalizeLegacyPath = (): void => {
  if (location.pathname === '/today' && !location.hash)
    history.replaceState(null, '', '/#/brief');
};

export const legacyDestination = (path: string): string | undefined =>
  path === '/today' ? '/brief' : path === '/conversion' ? '/dashboard' : undefined;
